import { render } from "./CommunityTalkMedia.vue?vue&type=template&id=a73adbda&ts=true"
import script from "./CommunityTalkMedia.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityTalkMedia.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityTalkMedia.vue?vue&type=style&index=0&id=a73adbda&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/CommunityTalkMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a73adbda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a73adbda', __exports__)) {
    api.reload('a73adbda', __exports__)
  }
  
  module.hot.accept("./CommunityTalkMedia.vue?vue&type=template&id=a73adbda&ts=true", () => {
    api.rerender('a73adbda', render)
  })

}


export default __exports__